import styled, { keyframes } from 'styled-components';

const animateButtonReload = keyframes`
  from {
    bottom: 20px;
    opacity: 0;
  }
  to {
    bottom: 80px;
    opacity: 1;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: calc(100vh - 120px);

  > button {
    width: 150px;
    margin-left: auto;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  background: #fff;
  border-radius: 6px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.08);
  padding: 35px 25px;
  width: 100%;
  min-height: 400px;
  max-width: 580px;
  margin-bottom: 40px;
  position: relative;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 30px;
  width: 100%;

  h1 {
    font-weight: bold;
    font-size: 20px;
    color: ${({ theme }) => theme.colors.graySecondary};
  }

  button {
    display: flex;
    align-items: center;

    color: ${({ theme }) => theme.colors.primary};
    background: transparent;
    border: none;

    span {
      font-weight: 600;
      font-size: 14px;
      margin-left: 10px;
    }
  }
`;

export const LoadingData = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
`;

export const ThereAreNoNotifications = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
  color: ${({ theme }) => theme.colors.grayAlternative};

  h1 {
    font-size: 30px;
    margin-top: 25px;
  }
`;

export const NotificationsList = styled.div`
  overflow-y: auto;
  width: 100%;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background: #fff;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: ${({ theme }) => theme.colors.gray1};
  }

  h3 {
    font-weight: 600;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.graySecondary};
    margin: 45px 0 25px;
  }

  > button {
    margin: 30px auto;
  }
`;

export const ButtonReload = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  max-width: 250px;
  height: 40px;
  background: ${({ theme }) => theme.colors.primary};
  color: #fff;
  position: absolute;
  bottom: 80px;
  border: none;
  border-radius: 50px;
  animation: ${animateButtonReload} 0.4s linear normal;

  strong {
    margin-left: 10px;
    font-size: 14px;
  }
`;
